// @flow
import React from 'react';
import Wrapper from './FormFieldWrapper';
import Text from './Typography';

type RadioProps = {
  id: number,
  label: string,
  checked: boolean,
  onToggle: (evt: Event) => void,
  onMouseUp: (evt: Event) => void,
  onMouseDown: (evt: Event) => void,
  index: number,
  isActive: boolean
}

const Radio = ({ id, label, checked, isActive, onMouseUp, onMouseDown }: RadioProps) => (
  <div
    className={`radio-item ${checked ? 'is-checked' : ''} ${isActive ? 'is-active' : ''}`}
    role='radio'
    tabIndex={0}
    aria-checked={checked}
    onMouseDown={() => onMouseDown(id)}
    onMouseUp={() => onMouseUp(id)}
    onKeyDown={(e) => {
      if (e.key === 'Enter') { onMouseDown(id); }
    }}
    onKeyUp={(e) => {
      if (e.key === 'Enter') { onMouseUp(id); }
    }}
  >
    <label
      className='control'
      htmlFor={`radio-item-${id}`}
    >
      <input
        type='radio'
        id={id}
        name={`radio-item-${id}`}
        value={id}
        checked={checked}
      />

      <Text paragraph align='center' className='label-text'>{label}</Text>
      <div className='radio-target is-boolean' />
    </label>
  </div>
);

type InputProps = {
  question: string,
  options: Array<{ id: number, text: string }>,
  selectedOption: Array<number>,
  setAnswer: (selectedOptions: Array) => void,
  className: string,
  children: any
}
class BooleanInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeButton: null
    };
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleMouseUp);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleMouseUp);
  }

  props: InputProps
  handleMouseUp = () => {
    this.setState({
      activeButton: null
    });
  }
  render() {
    const { options, selectedOption, className, question } = this.props;
    return (
      <Wrapper
        className={`field radio-input ${className}`}
        helpText={this.props.children}
      >
        {question ? <h3>{question}</h3> : ''}
        <div className='field-group is-horizontal'>
          {options.map((option) => {
            if (option.id) {
              return (
                <Radio
                  key={option.id}
                  label={option.text}
                  id={option.id}
                  checked={selectedOption === option.id}
                  isActive={this.state.activeButton === option.id}
                  onMouseUp={(e) => {
                    setTimeout(() => { this.props.setAnswer(e); }, 50);
                  }}
                  onMouseDown={() => {
                    this.setState({
                      activeButton: option.id
                    });
                  }}
                />
              );
            }
            return '';
          })}
        </div>
      </Wrapper>
    );
  }
}

export default BooleanInput;



// WEBPACK FOOTER //
// ./src/components/shared/BooleanInput.js